import { foxsyai } from '@launchpad/data/projects/foxsyai';
import { wisdomise } from '@launchpad/data/projects/wisdomise';

import { autoLayer } from './autoLayer';
import { chirpPad } from './chirpPad';
import { earnM } from './earnM';
import { fanton } from './fanton';
import { goodCryptoX } from './goodCryptoX';
import { gptWars } from './gptWars';
import { liveArt } from './liveArt';
import { metropolis } from './metropolis';
import { pinkMoon } from './pinkMoon';
import { primexFinance } from './primexFinance';
import { reformDAO } from './reformDAO';
import { sqrpSale } from './sqrpSale';
import { sqrSale } from './sqrSale';
import { stormTrade } from './stormTrade';
import type { ProjectContentData } from './types';

const projects = {
  [stormTrade.id]: stormTrade,
  [sqrpSale.id]: sqrpSale,
  [sqrSale.id]: sqrSale,
  [autoLayer.id]: autoLayer,
  [fanton.id]: fanton,
  [goodCryptoX.id]: goodCryptoX,
  [reformDAO.id]: reformDAO,
  [pinkMoon.id]: pinkMoon,
  [liveArt.id]: liveArt,
  [earnM.id]: earnM,
  [primexFinance.id]: primexFinance,
  [gptWars.id]: gptWars,
  [metropolis.id]: metropolis,
  [chirpPad.id]: chirpPad,
  [wisdomise.id]: wisdomise,
  [foxsyai.id]: foxsyai,
} as const;

export const getProjectContent = (projectId: string): ProjectContentData | undefined => {
  return projects[projectId];
};
